/** @jsx jsx */
import { jsx } from 'theme-ui';
import { forwardRef } from 'react';

export const ButtonToggle = forwardRef(({ children, pressed, onClick, ...rest }, ref) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      aria-pressed={pressed}
      tabIndex={0}
      {...rest}
      sx={{
        position: 'relative',
        fontSize: [1, 1, 2, 2],
        backgroundColor: 'transparent',
        appearance: 'none',
        textAlign: 'left',
        lineHeight: '1',
        textDecoration: 'none',
        fontWeight: 400,
        alignItems: 'center',
        p: 0,
        pr: 0,
        py: 5,
        border: 0,
        borderRadius: 0,
        color: pressed ? 'accent' : 'inherit',
        ':hover': {
          color: 'accent',
        },
        ':after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: 0,
          width: '100%',
          backgroundColor: pressed ? 'accent' : 'inherit',
          height: '1px',
        },
      }}
    >
      <span>{children}</span>
    </button>
  );
});
export default ButtonToggle;
